/* eslint-disable max-len */
import React from 'react';

function CaretDown() {
    return (
        <g>
            <path d="M12,17.7" />
            <path d="M0.2,5.1C0,5.3-0.1,5.6,0.1,5.8l11.5,13c0.1,0.1,0.2,0.2,0.4,0.2s0.3-0.1,0.4-0.2l11.5-13c0.2-0.2,0.2-0.5,0-0.7L0.2,5.1z" />
        </g>
    );
}

export default CaretDown;

